import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import StepsNavigation from '../../StepsNavigation';
import { MAIN_BUTTON_WIDTH_KEYS } from '../../MUI/MainButton';

const ClaimStepNavigationWrapper = ({
  setStepNavigationBox,
  isNextDisabled,
  isDeviceLgSize,
  errors,
  handleSubmit,
  onSubmit,
  back,
  dependencies,
  styles,
}) => {
  useEffect(() => {
    setStepNavigationBox(() => (
      <StepsNavigation
        styles={styles}
        next={() => handleSubmit(onSubmit)()}
        isNextValid={!!Object.keys(errors).length}
        isNextDisabled={isNextDisabled}
        back={back}
        width={isDeviceLgSize ? MAIN_BUTTON_WIDTH_KEYS.FULL_WIDTH : ''}
      />
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);

  return null;
};

ClaimStepNavigationWrapper.propTypes = {
  setStepNavigationBox: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
  isDeviceLgSize: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}).isRequired,
  styles: PropTypes.string,
  back: PropTypes.func,
  dependencies: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.shape({}),
    ]),
  ).isRequired,
};

ClaimStepNavigationWrapper.defaultProps = {
  back: undefined,
  styles: '',
};

export default ClaimStepNavigationWrapper;
